/**
 * Copyright IBM Corp. 2019, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { _ as _objectWithoutProperties, I as Icon, a as _extends } from '../Icon-83b9d1f1.js';
import '@carbon/icon-helpers';
import 'prop-types';
import React from 'react';

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.34 19H17.65V21H6.34z",
  transform: "rotate(-45 11.995 20.002)"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
});

var Rocket32 = /*#__PURE__*/React.forwardRef(function Rocket32(_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref2, _ref3, children);
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.34 19H17.65V21H6.34z",
  transform: "rotate(-45 11.995 20.002)"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
});

var Rocket24 = /*#__PURE__*/React.forwardRef(function Rocket24(_ref4, ref) {
  var children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref5, _ref6, children);
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.34 19H17.65V21H6.34z",
  transform: "rotate(-45 11.995 20.002)"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
});

var Rocket20 = /*#__PURE__*/React.forwardRef(function Rocket20(_ref7, ref) {
  var children = _ref7.children,
      rest = _objectWithoutProperties(_ref7, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref8, _ref9, children);
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.34 19H17.65V21H6.34z",
  transform: "rotate(-45 11.995 20.002)"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
});

var Rocket16 = /*#__PURE__*/React.forwardRef(function Rocket16(_ref10, ref) {
  var children = _ref10.children,
      rest = _objectWithoutProperties(_ref10, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref11, _ref12, children);
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
});

var Rotate32 = /*#__PURE__*/React.forwardRef(function Rotate32(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref14, children);
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
});

var Rotate24 = /*#__PURE__*/React.forwardRef(function Rotate24(_ref15, ref) {
  var children = _ref15.children,
      rest = _objectWithoutProperties(_ref15, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref16, children);
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
});

var Rotate20 = /*#__PURE__*/React.forwardRef(function Rotate20(_ref17, ref) {
  var children = _ref17.children,
      rest = _objectWithoutProperties(_ref17, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref18, children);
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
});

var Rotate16 = /*#__PURE__*/React.forwardRef(function Rotate16(_ref19, ref) {
  var children = _ref19.children,
      rest = _objectWithoutProperties(_ref19, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref20, children);
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
});

var WatsonHealthRotate_18032 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_18032(_ref21, ref) {
  var children = _ref21.children,
      rest = _objectWithoutProperties(_ref21, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref22, children);
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
});

var WatsonHealthRotate_18024 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_18024(_ref23, ref) {
  var children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref24, children);
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
});

var WatsonHealthRotate_18020 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_18020(_ref25, ref) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref26, children);
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
});

var WatsonHealthRotate_18016 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_18016(_ref27, ref) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref28, children);
});

var _ref30 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
});

var WatsonHealthRotate_36032 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_36032(_ref29, ref) {
  var children = _ref29.children,
      rest = _objectWithoutProperties(_ref29, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref30, children);
});

var _ref32 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
});

var WatsonHealthRotate_36024 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_36024(_ref31, ref) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref32, children);
});

var _ref34 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
});

var WatsonHealthRotate_36020 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_36020(_ref33, ref) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref34, children);
});

var _ref36 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
});

var WatsonHealthRotate_36016 = /*#__PURE__*/React.forwardRef(function WatsonHealthRotate_36016(_ref35, ref) {
  var children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref36, children);
});

var _ref38 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
});

var RotateClockwise32 = /*#__PURE__*/React.forwardRef(function RotateClockwise32(_ref37, ref) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref38, children);
});

var _ref40 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
});

var RotateClockwise24 = /*#__PURE__*/React.forwardRef(function RotateClockwise24(_ref39, ref) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref40, children);
});

var _ref42 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
});

var RotateClockwise20 = /*#__PURE__*/React.forwardRef(function RotateClockwise20(_ref41, ref) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref42, children);
});

var _ref44 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
});

var RotateClockwise16 = /*#__PURE__*/React.forwardRef(function RotateClockwise16(_ref43, ref) {
  var children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref44, children);
});

var _ref46 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
});

var RotateClockwiseAlt32 = /*#__PURE__*/React.forwardRef(function RotateClockwiseAlt32(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref46, children);
});

var _ref48 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
});

var RotateClockwiseAlt24 = /*#__PURE__*/React.forwardRef(function RotateClockwiseAlt24(_ref47, ref) {
  var children = _ref47.children,
      rest = _objectWithoutProperties(_ref47, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref48, children);
});

var _ref50 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
});

var RotateClockwiseAlt20 = /*#__PURE__*/React.forwardRef(function RotateClockwiseAlt20(_ref49, ref) {
  var children = _ref49.children,
      rest = _objectWithoutProperties(_ref49, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref50, children);
});

var _ref52 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
});

var RotateClockwiseAlt16 = /*#__PURE__*/React.forwardRef(function RotateClockwiseAlt16(_ref51, ref) {
  var children = _ref51.children,
      rest = _objectWithoutProperties(_ref51, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref52, children);
});

var _ref54 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
});

var RotateClockwiseAltFilled32 = /*#__PURE__*/React.forwardRef(function RotateClockwiseAltFilled32(_ref53, ref) {
  var children = _ref53.children,
      rest = _objectWithoutProperties(_ref53, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref54, children);
});

var _ref56 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
});

var RotateClockwiseAltFilled24 = /*#__PURE__*/React.forwardRef(function RotateClockwiseAltFilled24(_ref55, ref) {
  var children = _ref55.children,
      rest = _objectWithoutProperties(_ref55, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref56, children);
});

var _ref58 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
});

var RotateClockwiseAltFilled20 = /*#__PURE__*/React.forwardRef(function RotateClockwiseAltFilled20(_ref57, ref) {
  var children = _ref57.children,
      rest = _objectWithoutProperties(_ref57, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref58, children);
});

var _ref60 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
});

var RotateClockwiseAltFilled16 = /*#__PURE__*/React.forwardRef(function RotateClockwiseAltFilled16(_ref59, ref) {
  var children = _ref59.children,
      rest = _objectWithoutProperties(_ref59, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref60, children);
});

var _ref62 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
});

var RotateClockwiseFilled32 = /*#__PURE__*/React.forwardRef(function RotateClockwiseFilled32(_ref61, ref) {
  var children = _ref61.children,
      rest = _objectWithoutProperties(_ref61, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref62, children);
});

var _ref64 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
});

var RotateClockwiseFilled24 = /*#__PURE__*/React.forwardRef(function RotateClockwiseFilled24(_ref63, ref) {
  var children = _ref63.children,
      rest = _objectWithoutProperties(_ref63, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref64, children);
});

var _ref66 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
});

var RotateClockwiseFilled20 = /*#__PURE__*/React.forwardRef(function RotateClockwiseFilled20(_ref65, ref) {
  var children = _ref65.children,
      rest = _objectWithoutProperties(_ref65, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref66, children);
});

var _ref68 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
});

var RotateClockwiseFilled16 = /*#__PURE__*/React.forwardRef(function RotateClockwiseFilled16(_ref67, ref) {
  var children = _ref67.children,
      rest = _objectWithoutProperties(_ref67, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref68, children);
});

var _ref70 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
});

var RotateCounterclockwise32 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwise32(_ref69, ref) {
  var children = _ref69.children,
      rest = _objectWithoutProperties(_ref69, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref70, children);
});

var _ref72 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
});

var RotateCounterclockwise24 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwise24(_ref71, ref) {
  var children = _ref71.children,
      rest = _objectWithoutProperties(_ref71, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref72, children);
});

var _ref74 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
});

var RotateCounterclockwise20 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwise20(_ref73, ref) {
  var children = _ref73.children,
      rest = _objectWithoutProperties(_ref73, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref74, children);
});

var _ref76 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
});

var RotateCounterclockwise16 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwise16(_ref75, ref) {
  var children = _ref75.children,
      rest = _objectWithoutProperties(_ref75, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref76, children);
});

var _ref78 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
});

var RotateCounterclockwiseAlt32 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAlt32(_ref77, ref) {
  var children = _ref77.children,
      rest = _objectWithoutProperties(_ref77, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref78, children);
});

var _ref80 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
});

var RotateCounterclockwiseAlt24 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAlt24(_ref79, ref) {
  var children = _ref79.children,
      rest = _objectWithoutProperties(_ref79, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref80, children);
});

var _ref82 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
});

var RotateCounterclockwiseAlt20 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAlt20(_ref81, ref) {
  var children = _ref81.children,
      rest = _objectWithoutProperties(_ref81, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref82, children);
});

var _ref84 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
});

var RotateCounterclockwiseAlt16 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAlt16(_ref83, ref) {
  var children = _ref83.children,
      rest = _objectWithoutProperties(_ref83, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref84, children);
});

var _ref86 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
});

var RotateCounterclockwiseAltFilled32 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAltFilled32(_ref85, ref) {
  var children = _ref85.children,
      rest = _objectWithoutProperties(_ref85, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref86, children);
});

var _ref88 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
});

var RotateCounterclockwiseAltFilled24 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAltFilled24(_ref87, ref) {
  var children = _ref87.children,
      rest = _objectWithoutProperties(_ref87, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref88, children);
});

var _ref90 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
});

var RotateCounterclockwiseAltFilled20 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAltFilled20(_ref89, ref) {
  var children = _ref89.children,
      rest = _objectWithoutProperties(_ref89, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref90, children);
});

var _ref92 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
});

var RotateCounterclockwiseAltFilled16 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseAltFilled16(_ref91, ref) {
  var children = _ref91.children,
      rest = _objectWithoutProperties(_ref91, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref92, children);
});

var _ref94 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
});

var RotateCounterclockwiseFilled32 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseFilled32(_ref93, ref) {
  var children = _ref93.children,
      rest = _objectWithoutProperties(_ref93, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref94, children);
});

var _ref96 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
});

var RotateCounterclockwiseFilled24 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseFilled24(_ref95, ref) {
  var children = _ref95.children,
      rest = _objectWithoutProperties(_ref95, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref96, children);
});

var _ref98 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
});

var RotateCounterclockwiseFilled20 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseFilled20(_ref97, ref) {
  var children = _ref97.children,
      rest = _objectWithoutProperties(_ref97, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref98, children);
});

var _ref100 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
});

var RotateCounterclockwiseFilled16 = /*#__PURE__*/React.forwardRef(function RotateCounterclockwiseFilled16(_ref99, ref) {
  var children = _ref99.children,
      rest = _objectWithoutProperties(_ref99, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref100, children);
});

var _ref102 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
});

var Row32 = /*#__PURE__*/React.forwardRef(function Row32(_ref101, ref) {
  var children = _ref101.children,
      rest = _objectWithoutProperties(_ref101, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref102, children);
});

var _ref104 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
});

var Row24 = /*#__PURE__*/React.forwardRef(function Row24(_ref103, ref) {
  var children = _ref103.children,
      rest = _objectWithoutProperties(_ref103, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref104, children);
});

var _ref106 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
});

var Row20 = /*#__PURE__*/React.forwardRef(function Row20(_ref105, ref) {
  var children = _ref105.children,
      rest = _objectWithoutProperties(_ref105, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref106, children);
});

var _ref108 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
});

var Row16 = /*#__PURE__*/React.forwardRef(function Row16(_ref107, ref) {
  var children = _ref107.children,
      rest = _objectWithoutProperties(_ref107, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref108, children);
});

var _ref110 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
});

var RowCollapse32 = /*#__PURE__*/React.forwardRef(function RowCollapse32(_ref109, ref) {
  var children = _ref109.children,
      rest = _objectWithoutProperties(_ref109, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref110, children);
});

var _ref112 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
});

var RowCollapse24 = /*#__PURE__*/React.forwardRef(function RowCollapse24(_ref111, ref) {
  var children = _ref111.children,
      rest = _objectWithoutProperties(_ref111, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref112, children);
});

var _ref114 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
});

var RowCollapse20 = /*#__PURE__*/React.forwardRef(function RowCollapse20(_ref113, ref) {
  var children = _ref113.children,
      rest = _objectWithoutProperties(_ref113, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref114, children);
});

var _ref116 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
});

var RowCollapse16 = /*#__PURE__*/React.forwardRef(function RowCollapse16(_ref115, ref) {
  var children = _ref115.children,
      rest = _objectWithoutProperties(_ref115, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref116, children);
});

var _ref118 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
});

var RowExpand32 = /*#__PURE__*/React.forwardRef(function RowExpand32(_ref117, ref) {
  var children = _ref117.children,
      rest = _objectWithoutProperties(_ref117, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref118, children);
});

var _ref120 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
});

var RowExpand24 = /*#__PURE__*/React.forwardRef(function RowExpand24(_ref119, ref) {
  var children = _ref119.children,
      rest = _objectWithoutProperties(_ref119, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref120, children);
});

var _ref122 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
});

var RowExpand20 = /*#__PURE__*/React.forwardRef(function RowExpand20(_ref121, ref) {
  var children = _ref121.children,
      rest = _objectWithoutProperties(_ref121, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref122, children);
});

var _ref124 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
});

var RowExpand16 = /*#__PURE__*/React.forwardRef(function RowExpand16(_ref123, ref) {
  var children = _ref123.children,
      rest = _objectWithoutProperties(_ref123, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref124, children);
});

var _ref126 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
});

var _ref127 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
});

var Rss32 = /*#__PURE__*/React.forwardRef(function Rss32(_ref125, ref) {
  var children = _ref125.children,
      rest = _objectWithoutProperties(_ref125, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref126, _ref127, children);
});

var _ref129 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
});

var _ref130 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
});

var Rss24 = /*#__PURE__*/React.forwardRef(function Rss24(_ref128, ref) {
  var children = _ref128.children,
      rest = _objectWithoutProperties(_ref128, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref129, _ref130, children);
});

var _ref132 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
});

var _ref133 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
});

var Rss20 = /*#__PURE__*/React.forwardRef(function Rss20(_ref131, ref) {
  var children = _ref131.children,
      rest = _objectWithoutProperties(_ref131, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref132, _ref133, children);
});

var _ref135 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
});

var _ref136 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
});

var Rss16 = /*#__PURE__*/React.forwardRef(function Rss16(_ref134, ref) {
  var children = _ref134.children,
      rest = _objectWithoutProperties(_ref134, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref135, _ref136, children);
});

var _ref138 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16H22V18H10zM10 10H22V12H10z"
});

var _ref139 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
});

var Rule32 = /*#__PURE__*/React.forwardRef(function Rule32(_ref137, ref) {
  var children = _ref137.children,
      rest = _objectWithoutProperties(_ref137, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref138, _ref139, children);
});

var _ref141 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16H22V18H10zM10 10H22V12H10z"
});

var _ref142 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
});

var Rule24 = /*#__PURE__*/React.forwardRef(function Rule24(_ref140, ref) {
  var children = _ref140.children,
      rest = _objectWithoutProperties(_ref140, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref141, _ref142, children);
});

var _ref144 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16H22V18H10zM10 10H22V12H10z"
});

var _ref145 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
});

var Rule20 = /*#__PURE__*/React.forwardRef(function Rule20(_ref143, ref) {
  var children = _ref143.children,
      rest = _objectWithoutProperties(_ref143, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref144, _ref145, children);
});

var _ref147 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M10 16H22V18H10zM10 10H22V12H10z"
});

var _ref148 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
});

var Rule16 = /*#__PURE__*/React.forwardRef(function Rule16(_ref146, ref) {
  var children = _ref146.children,
      rest = _objectWithoutProperties(_ref146, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref147, _ref148, children);
});

var _ref150 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
});

var Ruler32 = /*#__PURE__*/React.forwardRef(function Ruler32(_ref149, ref) {
  var children = _ref149.children,
      rest = _objectWithoutProperties(_ref149, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref150, children);
});

var _ref152 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
});

var Ruler24 = /*#__PURE__*/React.forwardRef(function Ruler24(_ref151, ref) {
  var children = _ref151.children,
      rest = _objectWithoutProperties(_ref151, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref152, children);
});

var _ref154 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
});

var Ruler20 = /*#__PURE__*/React.forwardRef(function Ruler20(_ref153, ref) {
  var children = _ref153.children,
      rest = _objectWithoutProperties(_ref153, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref154, children);
});

var _ref156 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
});

var Ruler16 = /*#__PURE__*/React.forwardRef(function Ruler16(_ref155, ref) {
  var children = _ref155.children,
      rest = _objectWithoutProperties(_ref155, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref156, children);
});

var _ref158 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
});

var RulerAlt32 = /*#__PURE__*/React.forwardRef(function RulerAlt32(_ref157, ref) {
  var children = _ref157.children,
      rest = _objectWithoutProperties(_ref157, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref158, children);
});

var _ref160 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
});

var RulerAlt24 = /*#__PURE__*/React.forwardRef(function RulerAlt24(_ref159, ref) {
  var children = _ref159.children,
      rest = _objectWithoutProperties(_ref159, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref160, children);
});

var _ref162 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
});

var RulerAlt20 = /*#__PURE__*/React.forwardRef(function RulerAlt20(_ref161, ref) {
  var children = _ref161.children,
      rest = _objectWithoutProperties(_ref161, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref162, children);
});

var _ref164 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
});

var RulerAlt16 = /*#__PURE__*/React.forwardRef(function RulerAlt16(_ref163, ref) {
  var children = _ref163.children,
      rest = _objectWithoutProperties(_ref163, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref164, children);
});

var _ref166 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
});

var _ref167 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
});

var _ref168 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 19L19 25 24 22 19 19z"
});

var Run32 = /*#__PURE__*/React.forwardRef(function Run32(_ref165, ref) {
  var children = _ref165.children,
      rest = _objectWithoutProperties(_ref165, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref166, _ref167, _ref168, children);
});

var _ref170 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
});

var _ref171 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
});

var _ref172 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 19L19 25 24 22 19 19z"
});

var Run24 = /*#__PURE__*/React.forwardRef(function Run24(_ref169, ref) {
  var children = _ref169.children,
      rest = _objectWithoutProperties(_ref169, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref170, _ref171, _ref172, children);
});

var _ref174 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
});

var _ref175 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
});

var _ref176 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 19L19 25 24 22 19 19z"
});

var Run20 = /*#__PURE__*/React.forwardRef(function Run20(_ref173, ref) {
  var children = _ref173.children,
      rest = _objectWithoutProperties(_ref173, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref174, _ref175, _ref176, children);
});

var _ref178 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
});

var _ref179 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
});

var _ref180 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19 19L19 25 24 22 19 19z"
});

var Run16 = /*#__PURE__*/React.forwardRef(function Run16(_ref177, ref) {
  var children = _ref177.children,
      rest = _objectWithoutProperties(_ref177, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref178, _ref179, _ref180, children);
});

var _ref182 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
});

var QS32 = /*#__PURE__*/React.forwardRef(function QS32(_ref181, ref) {
  var children = _ref181.children,
      rest = _objectWithoutProperties(_ref181, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref182, children);
});

var _ref184 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
});

var QS24 = /*#__PURE__*/React.forwardRef(function QS24(_ref183, ref) {
  var children = _ref183.children,
      rest = _objectWithoutProperties(_ref183, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref184, children);
});

var _ref186 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
});

var QS20 = /*#__PURE__*/React.forwardRef(function QS20(_ref185, ref) {
  var children = _ref185.children,
      rest = _objectWithoutProperties(_ref185, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref186, children);
});

var _ref188 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
});

var QS16 = /*#__PURE__*/React.forwardRef(function QS16(_ref187, ref) {
  var children = _ref187.children,
      rest = _objectWithoutProperties(_ref187, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref188, children);
});

var _ref190 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
});

var QSAlt32 = /*#__PURE__*/React.forwardRef(function QSAlt32(_ref189, ref) {
  var children = _ref189.children,
      rest = _objectWithoutProperties(_ref189, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref190, children);
});

var _ref192 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
});

var QSAlt24 = /*#__PURE__*/React.forwardRef(function QSAlt24(_ref191, ref) {
  var children = _ref191.children,
      rest = _objectWithoutProperties(_ref191, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref192, children);
});

var _ref194 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
});

var QSAlt20 = /*#__PURE__*/React.forwardRef(function QSAlt20(_ref193, ref) {
  var children = _ref193.children,
      rest = _objectWithoutProperties(_ref193, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref194, children);
});

var _ref196 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
});

var QSAlt16 = /*#__PURE__*/React.forwardRef(function QSAlt16(_ref195, ref) {
  var children = _ref195.children,
      rest = _objectWithoutProperties(_ref195, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref196, children);
});

var _ref198 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z"
});

var Save32 = /*#__PURE__*/React.forwardRef(function Save32(_ref197, ref) {
  var children = _ref197.children,
      rest = _objectWithoutProperties(_ref197, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref198, children);
});

var _ref200 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12\tC21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6\th-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z"
});

var Save24 = /*#__PURE__*/React.forwardRef(function Save24(_ref199, ref) {
  var children = _ref199.children,
      rest = _objectWithoutProperties(_ref199, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref200, children);
});

var _ref202 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1\tC18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3\tc0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4\tL14,16.7L14,16.7z"
});

var Save20 = /*#__PURE__*/React.forwardRef(function Save20(_ref201, ref) {
  var children = _ref201.children,
      rest = _objectWithoutProperties(_ref201, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref202, children);
});

var _ref204 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5\tC14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1\th4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z"
});

var Save16 = /*#__PURE__*/React.forwardRef(function Save16(_ref203, ref) {
  var children = _ref203.children,
      rest = _objectWithoutProperties(_ref203, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref204, children);
});

var _ref206 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref207 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
});

var _ref208 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6H26V8H20zM22 10H26V12H22z"
});

var WatsonHealthSaveAnnotation32 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveAnnotation32(_ref205, ref) {
  var children = _ref205.children,
      rest = _objectWithoutProperties(_ref205, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref206, _ref207, _ref208, children);
});

var _ref210 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref211 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
});

var _ref212 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6H26V8H20zM22 10H26V12H22z"
});

var WatsonHealthSaveAnnotation24 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveAnnotation24(_ref209, ref) {
  var children = _ref209.children,
      rest = _objectWithoutProperties(_ref209, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref210, _ref211, _ref212, children);
});

var _ref214 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref215 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
});

var _ref216 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6H26V8H20zM22 10H26V12H22z"
});

var WatsonHealthSaveAnnotation20 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveAnnotation20(_ref213, ref) {
  var children = _ref213.children,
      rest = _objectWithoutProperties(_ref213, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref214, _ref215, _ref216, children);
});

var _ref218 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref219 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
});

var _ref220 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 6H26V8H20zM22 10H26V12H22z"
});

var WatsonHealthSaveAnnotation16 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveAnnotation16(_ref217, ref) {
  var children = _ref217.children,
      rest = _objectWithoutProperties(_ref217, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref218, _ref219, _ref220, children);
});

var _ref222 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref223 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
});

var WatsonHealthSaveImage32 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveImage32(_ref221, ref) {
  var children = _ref221.children,
      rest = _objectWithoutProperties(_ref221, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref222, _ref223, children);
});

var _ref225 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref226 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
});

var WatsonHealthSaveImage24 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveImage24(_ref224, ref) {
  var children = _ref224.children,
      rest = _objectWithoutProperties(_ref224, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref225, _ref226, children);
});

var _ref228 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref229 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
});

var WatsonHealthSaveImage20 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveImage20(_ref227, ref) {
  var children = _ref227.children,
      rest = _objectWithoutProperties(_ref227, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref228, _ref229, children);
});

var _ref231 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref232 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
});

var WatsonHealthSaveImage16 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveImage16(_ref230, ref) {
  var children = _ref230.children,
      rest = _objectWithoutProperties(_ref230, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref231, _ref232, children);
});

var _ref234 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
});

var _ref235 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
});

var SaveModel32 = /*#__PURE__*/React.forwardRef(function SaveModel32(_ref233, ref) {
  var children = _ref233.children,
      rest = _objectWithoutProperties(_ref233, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref234, _ref235, children);
});

var _ref237 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
});

var _ref238 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
});

var SaveModel24 = /*#__PURE__*/React.forwardRef(function SaveModel24(_ref236, ref) {
  var children = _ref236.children,
      rest = _objectWithoutProperties(_ref236, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref237, _ref238, children);
});

var _ref240 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
});

var _ref241 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
});

var SaveModel20 = /*#__PURE__*/React.forwardRef(function SaveModel20(_ref239, ref) {
  var children = _ref239.children,
      rest = _objectWithoutProperties(_ref239, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref240, _ref241, children);
});

var _ref243 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
});

var _ref244 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
});

var SaveModel16 = /*#__PURE__*/React.forwardRef(function SaveModel16(_ref242, ref) {
  var children = _ref242.children,
      rest = _objectWithoutProperties(_ref242, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref243, _ref244, children);
});

var _ref246 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref247 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
});

var _ref248 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
});

var WatsonHealthSaveSeries32 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveSeries32(_ref245, ref) {
  var children = _ref245.children,
      rest = _objectWithoutProperties(_ref245, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref246, _ref247, _ref248, children);
});

var _ref250 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref251 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
});

var _ref252 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
});

var WatsonHealthSaveSeries24 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveSeries24(_ref249, ref) {
  var children = _ref249.children,
      rest = _objectWithoutProperties(_ref249, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref250, _ref251, _ref252, children);
});

var _ref254 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref255 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
});

var _ref256 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
});

var WatsonHealthSaveSeries20 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveSeries20(_ref253, ref) {
  var children = _ref253.children,
      rest = _objectWithoutProperties(_ref253, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref254, _ref255, _ref256, children);
});

var _ref258 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
});

var _ref259 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
});

var _ref260 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
});

var WatsonHealthSaveSeries16 = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveSeries16(_ref257, ref) {
  var children = _ref257.children,
      rest = _objectWithoutProperties(_ref257, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref258, _ref259, _ref260, children);
});

var _ref262 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
});

var _ref263 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
});

var Scale32 = /*#__PURE__*/React.forwardRef(function Scale32(_ref261, ref) {
  var children = _ref261.children,
      rest = _objectWithoutProperties(_ref261, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref262, _ref263, children);
});

var _ref265 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
});

var _ref266 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
});

var Scale24 = /*#__PURE__*/React.forwardRef(function Scale24(_ref264, ref) {
  var children = _ref264.children,
      rest = _objectWithoutProperties(_ref264, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref265, _ref266, children);
});

var _ref268 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
});

var _ref269 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
});

var Scale20 = /*#__PURE__*/React.forwardRef(function Scale20(_ref267, ref) {
  var children = _ref267.children,
      rest = _objectWithoutProperties(_ref267, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref268, _ref269, children);
});

var _ref271 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
});

var _ref272 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
});

var Scale16 = /*#__PURE__*/React.forwardRef(function Scale16(_ref270, ref) {
  var children = _ref270.children,
      rest = _objectWithoutProperties(_ref270, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref271, _ref272, children);
});

var _ref274 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
});

var Scalpel32 = /*#__PURE__*/React.forwardRef(function Scalpel32(_ref273, ref) {
  var children = _ref273.children,
      rest = _objectWithoutProperties(_ref273, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref274, children);
});

var _ref276 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
});

var Scalpel24 = /*#__PURE__*/React.forwardRef(function Scalpel24(_ref275, ref) {
  var children = _ref275.children,
      rest = _objectWithoutProperties(_ref275, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref276, children);
});

var _ref278 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
});

var Scalpel20 = /*#__PURE__*/React.forwardRef(function Scalpel20(_ref277, ref) {
  var children = _ref277.children,
      rest = _objectWithoutProperties(_ref277, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref278, children);
});

var _ref280 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
});

var Scalpel16 = /*#__PURE__*/React.forwardRef(function Scalpel16(_ref279, ref) {
  var children = _ref279.children,
      rest = _objectWithoutProperties(_ref279, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref280, children);
});

var _ref282 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
});

var WatsonHealthScalpelCursor32 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelCursor32(_ref281, ref) {
  var children = _ref281.children,
      rest = _objectWithoutProperties(_ref281, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref282, children);
});

var _ref284 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
});

var WatsonHealthScalpelCursor24 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelCursor24(_ref283, ref) {
  var children = _ref283.children,
      rest = _objectWithoutProperties(_ref283, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref284, children);
});

var _ref286 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
});

var WatsonHealthScalpelCursor20 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelCursor20(_ref285, ref) {
  var children = _ref285.children,
      rest = _objectWithoutProperties(_ref285, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref286, children);
});

var _ref288 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
});

var WatsonHealthScalpelCursor16 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelCursor16(_ref287, ref) {
  var children = _ref287.children,
      rest = _objectWithoutProperties(_ref287, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref288, children);
});

var _ref290 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
});

var WatsonHealthScalpelLasso32 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelLasso32(_ref289, ref) {
  var children = _ref289.children,
      rest = _objectWithoutProperties(_ref289, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref290, children);
});

var _ref292 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
});

var WatsonHealthScalpelLasso24 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelLasso24(_ref291, ref) {
  var children = _ref291.children,
      rest = _objectWithoutProperties(_ref291, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref292, children);
});

var _ref294 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
});

var WatsonHealthScalpelLasso20 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelLasso20(_ref293, ref) {
  var children = _ref293.children,
      rest = _objectWithoutProperties(_ref293, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref294, children);
});

var _ref296 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
});

var WatsonHealthScalpelLasso16 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelLasso16(_ref295, ref) {
  var children = _ref295.children,
      rest = _objectWithoutProperties(_ref295, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref296, children);
});

var _ref298 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
});

var WatsonHealthScalpelSelect32 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelSelect32(_ref297, ref) {
  var children = _ref297.children,
      rest = _objectWithoutProperties(_ref297, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref298, children);
});

var _ref300 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
});

var WatsonHealthScalpelSelect24 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelSelect24(_ref299, ref) {
  var children = _ref299.children,
      rest = _objectWithoutProperties(_ref299, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref300, children);
});

var _ref302 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
});

var WatsonHealthScalpelSelect20 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelSelect20(_ref301, ref) {
  var children = _ref301.children,
      rest = _objectWithoutProperties(_ref301, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref302, children);
});

var _ref304 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
});

var WatsonHealthScalpelSelect16 = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelSelect16(_ref303, ref) {
  var children = _ref303.children,
      rest = _objectWithoutProperties(_ref303, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref304, children);
});

var _ref306 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
});

var _ref307 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
});

var Scan32 = /*#__PURE__*/React.forwardRef(function Scan32(_ref305, ref) {
  var children = _ref305.children,
      rest = _objectWithoutProperties(_ref305, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref306, _ref307, children);
});

var _ref309 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
});

var _ref310 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
});

var Scan24 = /*#__PURE__*/React.forwardRef(function Scan24(_ref308, ref) {
  var children = _ref308.children,
      rest = _objectWithoutProperties(_ref308, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref309, _ref310, children);
});

var _ref312 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
});

var _ref313 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
});

var Scan20 = /*#__PURE__*/React.forwardRef(function Scan20(_ref311, ref) {
  var children = _ref311.children,
      rest = _objectWithoutProperties(_ref311, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref312, _ref313, children);
});

var _ref315 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
});

var _ref316 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
});

var Scan16 = /*#__PURE__*/React.forwardRef(function Scan16(_ref314, ref) {
  var children = _ref314.children,
      rest = _objectWithoutProperties(_ref314, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref315, _ref316, children);
});

var _ref318 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9.5",
  cy: "9.5",
  r: "2.5"
});

var _ref319 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9.5",
  cy: "22.5",
  r: "2.5"
});

var _ref320 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22.5",
  cy: "22.5",
  r: "2.5"
});

var _ref321 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
});

var ScatterMatrix32 = /*#__PURE__*/React.forwardRef(function ScatterMatrix32(_ref317, ref) {
  var children = _ref317.children,
      rest = _objectWithoutProperties(_ref317, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref318, _ref319, _ref320, _ref321, children);
});

var _ref323 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9.5",
  cy: "9.5",
  r: "2.5"
});

var _ref324 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9.5",
  cy: "22.5",
  r: "2.5"
});

var _ref325 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22.5",
  cy: "22.5",
  r: "2.5"
});

var _ref326 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
});

var ScatterMatrix24 = /*#__PURE__*/React.forwardRef(function ScatterMatrix24(_ref322, ref) {
  var children = _ref322.children,
      rest = _objectWithoutProperties(_ref322, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref323, _ref324, _ref325, _ref326, children);
});

var _ref328 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9.5",
  cy: "9.5",
  r: "2.5"
});

var _ref329 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9.5",
  cy: "22.5",
  r: "2.5"
});

var _ref330 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22.5",
  cy: "22.5",
  r: "2.5"
});

var _ref331 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
});

var ScatterMatrix20 = /*#__PURE__*/React.forwardRef(function ScatterMatrix20(_ref327, ref) {
  var children = _ref327.children,
      rest = _objectWithoutProperties(_ref327, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref328, _ref329, _ref330, _ref331, children);
});

var _ref333 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9.5",
  cy: "9.5",
  r: "2.5"
});

var _ref334 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "9.5",
  cy: "22.5",
  r: "2.5"
});

var _ref335 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "22.5",
  cy: "22.5",
  r: "2.5"
});

var _ref336 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
});

var ScatterMatrix16 = /*#__PURE__*/React.forwardRef(function ScatterMatrix16(_ref332, ref) {
  var children = _ref332.children,
      rest = _objectWithoutProperties(_ref332, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref333, _ref334, _ref335, _ref336, children);
});

var _ref338 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
});

var Schematics32 = /*#__PURE__*/React.forwardRef(function Schematics32(_ref337, ref) {
  var children = _ref337.children,
      rest = _objectWithoutProperties(_ref337, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref338, children);
});

var _ref340 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
});

var Schematics24 = /*#__PURE__*/React.forwardRef(function Schematics24(_ref339, ref) {
  var children = _ref339.children,
      rest = _objectWithoutProperties(_ref339, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref340, children);
});

var _ref342 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
});

var Schematics20 = /*#__PURE__*/React.forwardRef(function Schematics20(_ref341, ref) {
  var children = _ref341.children,
      rest = _objectWithoutProperties(_ref341, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref342, children);
});

var _ref344 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
});

var Schematics16 = /*#__PURE__*/React.forwardRef(function Schematics16(_ref343, ref) {
  var children = _ref343.children,
      rest = _objectWithoutProperties(_ref343, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref344, children);
});

var _ref346 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
});

var Scooter32 = /*#__PURE__*/React.forwardRef(function Scooter32(_ref345, ref) {
  var children = _ref345.children,
      rest = _objectWithoutProperties(_ref345, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref346, children);
});

var _ref348 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
});

var Scooter24 = /*#__PURE__*/React.forwardRef(function Scooter24(_ref347, ref) {
  var children = _ref347.children,
      rest = _objectWithoutProperties(_ref347, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref348, children);
});

var _ref350 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
});

var Scooter20 = /*#__PURE__*/React.forwardRef(function Scooter20(_ref349, ref) {
  var children = _ref349.children,
      rest = _objectWithoutProperties(_ref349, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref350, children);
});

var _ref352 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
});

var Scooter16 = /*#__PURE__*/React.forwardRef(function Scooter16(_ref351, ref) {
  var children = _ref351.children,
      rest = _objectWithoutProperties(_ref351, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref352, children);
});

var _ref354 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 19H17V28H15z"
});

var _ref355 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
});

var ScooterFront32 = /*#__PURE__*/React.forwardRef(function ScooterFront32(_ref353, ref) {
  var children = _ref353.children,
      rest = _objectWithoutProperties(_ref353, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref354, _ref355, children);
});

var _ref357 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 19H17V28H15z"
});

var _ref358 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
});

var ScooterFront24 = /*#__PURE__*/React.forwardRef(function ScooterFront24(_ref356, ref) {
  var children = _ref356.children,
      rest = _objectWithoutProperties(_ref356, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref357, _ref358, children);
});

var _ref360 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 19H17V28H15z"
});

var _ref361 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
});

var ScooterFront20 = /*#__PURE__*/React.forwardRef(function ScooterFront20(_ref359, ref) {
  var children = _ref359.children,
      rest = _objectWithoutProperties(_ref359, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref360, _ref361, children);
});

var _ref363 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 19H17V28H15z"
});

var _ref364 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
});

var ScooterFront16 = /*#__PURE__*/React.forwardRef(function ScooterFront16(_ref362, ref) {
  var children = _ref362.children,
      rest = _objectWithoutProperties(_ref362, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref363, _ref364, children);
});

var _ref366 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
});

var Screen32 = /*#__PURE__*/React.forwardRef(function Screen32(_ref365, ref) {
  var children = _ref365.children,
      rest = _objectWithoutProperties(_ref365, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref366, children);
});

var _ref368 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
});

var Screen24 = /*#__PURE__*/React.forwardRef(function Screen24(_ref367, ref) {
  var children = _ref367.children,
      rest = _objectWithoutProperties(_ref367, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref368, children);
});

var _ref370 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
});

var Screen20 = /*#__PURE__*/React.forwardRef(function Screen20(_ref369, ref) {
  var children = _ref369.children,
      rest = _objectWithoutProperties(_ref369, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref370, children);
});

var _ref372 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
});

var Screen16 = /*#__PURE__*/React.forwardRef(function Screen16(_ref371, ref) {
  var children = _ref371.children,
      rest = _objectWithoutProperties(_ref371, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref372, children);
});

var _ref374 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
});

var ScreenOff32 = /*#__PURE__*/React.forwardRef(function ScreenOff32(_ref373, ref) {
  var children = _ref373.children,
      rest = _objectWithoutProperties(_ref373, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref374, children);
});

var _ref376 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
});

var ScreenOff24 = /*#__PURE__*/React.forwardRef(function ScreenOff24(_ref375, ref) {
  var children = _ref375.children,
      rest = _objectWithoutProperties(_ref375, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref376, children);
});

var _ref378 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
});

var ScreenOff20 = /*#__PURE__*/React.forwardRef(function ScreenOff20(_ref377, ref) {
  var children = _ref377.children,
      rest = _objectWithoutProperties(_ref377, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref378, children);
});

var _ref380 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
});

var ScreenOff16 = /*#__PURE__*/React.forwardRef(function ScreenOff16(_ref379, ref) {
  var children = _ref379.children,
      rest = _objectWithoutProperties(_ref379, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref380, children);
});

var _ref382 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
});

var _ref383 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
});

var Script32 = /*#__PURE__*/React.forwardRef(function Script32(_ref381, ref) {
  var children = _ref381.children,
      rest = _objectWithoutProperties(_ref381, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref382, _ref383, children);
});

var _ref385 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
});

var _ref386 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
});

var Script24 = /*#__PURE__*/React.forwardRef(function Script24(_ref384, ref) {
  var children = _ref384.children,
      rest = _objectWithoutProperties(_ref384, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref385, _ref386, children);
});

var _ref388 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
});

var _ref389 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
});

var Script20 = /*#__PURE__*/React.forwardRef(function Script20(_ref387, ref) {
  var children = _ref387.children,
      rest = _objectWithoutProperties(_ref387, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref388, _ref389, children);
});

var _ref391 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
});

var _ref392 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
});

var Script16 = /*#__PURE__*/React.forwardRef(function Script16(_ref390, ref) {
  var children = _ref390.children,
      rest = _objectWithoutProperties(_ref390, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref391, _ref392, children);
});

var _ref394 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
});

var ScriptReference32 = /*#__PURE__*/React.forwardRef(function ScriptReference32(_ref393, ref) {
  var children = _ref393.children,
      rest = _objectWithoutProperties(_ref393, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref394, children);
});

var _ref396 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
});

var ScriptReference24 = /*#__PURE__*/React.forwardRef(function ScriptReference24(_ref395, ref) {
  var children = _ref395.children,
      rest = _objectWithoutProperties(_ref395, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref396, children);
});

var _ref398 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
});

var ScriptReference20 = /*#__PURE__*/React.forwardRef(function ScriptReference20(_ref397, ref) {
  var children = _ref397.children,
      rest = _objectWithoutProperties(_ref397, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref398, children);
});

var _ref400 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
});

var ScriptReference16 = /*#__PURE__*/React.forwardRef(function ScriptReference16(_ref399, ref) {
  var children = _ref399.children,
      rest = _objectWithoutProperties(_ref399, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref400, children);
});

var _ref402 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
});

var Sdk32 = /*#__PURE__*/React.forwardRef(function Sdk32(_ref401, ref) {
  var children = _ref401.children,
      rest = _objectWithoutProperties(_ref401, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref402, children);
});

var _ref404 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
});

var Sdk24 = /*#__PURE__*/React.forwardRef(function Sdk24(_ref403, ref) {
  var children = _ref403.children,
      rest = _objectWithoutProperties(_ref403, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref404, children);
});

var _ref406 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
});

var Sdk20 = /*#__PURE__*/React.forwardRef(function Sdk20(_ref405, ref) {
  var children = _ref405.children,
      rest = _objectWithoutProperties(_ref405, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref406, children);
});

var _ref408 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
});

var Sdk16 = /*#__PURE__*/React.forwardRef(function Sdk16(_ref407, ref) {
  var children = _ref407.children,
      rest = _objectWithoutProperties(_ref407, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref408, children);
});

var _ref410 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,28.59,22.45,21A11,11,0,1,0,21,22.45L28.59,30ZM5,14a9,9,0,1,1,9,9A9,9,0,0,1,5,14Z"
});

var Search32 = /*#__PURE__*/React.forwardRef(function Search32(_ref409, ref) {
  var children = _ref409.children,
      rest = _objectWithoutProperties(_ref409, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref410, children);
});

var _ref412 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,28.59,22.45,21A11,11,0,1,0,21,22.45L28.59,30ZM5,14a9,9,0,1,1,9,9A9,9,0,0,1,5,14Z"
});

var Search24 = /*#__PURE__*/React.forwardRef(function Search24(_ref411, ref) {
  var children = _ref411.children,
      rest = _objectWithoutProperties(_ref411, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref412, children);
});

var _ref414 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30,28.59,22.45,21A11,11,0,1,0,21,22.45L28.59,30ZM5,14a9,9,0,1,1,9,9A9,9,0,0,1,5,14Z"
});

var Search20 = /*#__PURE__*/React.forwardRef(function Search20(_ref413, ref) {
  var children = _ref413.children,
      rest = _objectWithoutProperties(_ref413, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref414, children);
});

var _ref416 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5\tC2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z"
});

var Search16 = /*#__PURE__*/React.forwardRef(function Search16(_ref415, ref) {
  var children = _ref415.children,
      rest = _objectWithoutProperties(_ref415, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref416, children);
});

var _ref418 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
});

var _ref419 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
});

var Security32 = /*#__PURE__*/React.forwardRef(function Security32(_ref417, ref) {
  var children = _ref417.children,
      rest = _objectWithoutProperties(_ref417, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref418, _ref419, children);
});

var _ref421 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
});

var _ref422 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
});

var Security24 = /*#__PURE__*/React.forwardRef(function Security24(_ref420, ref) {
  var children = _ref420.children,
      rest = _objectWithoutProperties(_ref420, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref421, _ref422, children);
});

var _ref424 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
});

var _ref425 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
});

var Security20 = /*#__PURE__*/React.forwardRef(function Security20(_ref423, ref) {
  var children = _ref423.children,
      rest = _objectWithoutProperties(_ref423, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref424, _ref425, children);
});

var _ref427 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
});

var _ref428 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
});

var Security16 = /*#__PURE__*/React.forwardRef(function Security16(_ref426, ref) {
  var children = _ref426.children,
      rest = _objectWithoutProperties(_ref426, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref427, _ref428, children);
});

var _ref430 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
});

var Select_0132 = /*#__PURE__*/React.forwardRef(function Select_0132(_ref429, ref) {
  var children = _ref429.children,
      rest = _objectWithoutProperties(_ref429, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref430, children);
});

var _ref432 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
});

var Select_0124 = /*#__PURE__*/React.forwardRef(function Select_0124(_ref431, ref) {
  var children = _ref431.children,
      rest = _objectWithoutProperties(_ref431, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref432, children);
});

var _ref434 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
});

var Select_0120 = /*#__PURE__*/React.forwardRef(function Select_0120(_ref433, ref) {
  var children = _ref433.children,
      rest = _objectWithoutProperties(_ref433, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref434, children);
});

var _ref436 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
});

var Select_0116 = /*#__PURE__*/React.forwardRef(function Select_0116(_ref435, ref) {
  var children = _ref435.children,
      rest = _objectWithoutProperties(_ref435, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref436, children);
});

var _ref438 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
});

var Select_0232 = /*#__PURE__*/React.forwardRef(function Select_0232(_ref437, ref) {
  var children = _ref437.children,
      rest = _objectWithoutProperties(_ref437, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref438, children);
});

var _ref440 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
});

var Select_0224 = /*#__PURE__*/React.forwardRef(function Select_0224(_ref439, ref) {
  var children = _ref439.children,
      rest = _objectWithoutProperties(_ref439, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref440, children);
});

var _ref442 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
});

var Select_0220 = /*#__PURE__*/React.forwardRef(function Select_0220(_ref441, ref) {
  var children = _ref441.children,
      rest = _objectWithoutProperties(_ref441, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref442, children);
});

var _ref444 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
});

var Select_0216 = /*#__PURE__*/React.forwardRef(function Select_0216(_ref443, ref) {
  var children = _ref443.children,
      rest = _objectWithoutProperties(_ref443, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref444, children);
});

var _ref446 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
});

var Send32 = /*#__PURE__*/React.forwardRef(function Send32(_ref445, ref) {
  var children = _ref445.children,
      rest = _objectWithoutProperties(_ref445, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref446, children);
});

var _ref448 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
});

var Send24 = /*#__PURE__*/React.forwardRef(function Send24(_ref447, ref) {
  var children = _ref447.children,
      rest = _objectWithoutProperties(_ref447, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref448, children);
});

var _ref450 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
});

var Send20 = /*#__PURE__*/React.forwardRef(function Send20(_ref449, ref) {
  var children = _ref449.children,
      rest = _objectWithoutProperties(_ref449, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref450, children);
});

var _ref452 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
});

var Send16 = /*#__PURE__*/React.forwardRef(function Send16(_ref451, ref) {
  var children = _ref451.children,
      rest = _objectWithoutProperties(_ref451, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref452, children);
});

var _ref454 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
});

var SendAlt32 = /*#__PURE__*/React.forwardRef(function SendAlt32(_ref453, ref) {
  var children = _ref453.children,
      rest = _objectWithoutProperties(_ref453, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref454, children);
});

var _ref456 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
});

var SendAlt24 = /*#__PURE__*/React.forwardRef(function SendAlt24(_ref455, ref) {
  var children = _ref455.children,
      rest = _objectWithoutProperties(_ref455, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref456, children);
});

var _ref458 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
});

var SendAlt20 = /*#__PURE__*/React.forwardRef(function SendAlt20(_ref457, ref) {
  var children = _ref457.children,
      rest = _objectWithoutProperties(_ref457, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref458, children);
});

var _ref460 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
});

var SendAlt16 = /*#__PURE__*/React.forwardRef(function SendAlt16(_ref459, ref) {
  var children = _ref459.children,
      rest = _objectWithoutProperties(_ref459, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref460, children);
});

var _ref462 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
});

var SendAltFilled32 = /*#__PURE__*/React.forwardRef(function SendAltFilled32(_ref461, ref) {
  var children = _ref461.children,
      rest = _objectWithoutProperties(_ref461, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref462, children);
});

var _ref464 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
});

var SendAltFilled24 = /*#__PURE__*/React.forwardRef(function SendAltFilled24(_ref463, ref) {
  var children = _ref463.children,
      rest = _objectWithoutProperties(_ref463, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref464, children);
});

var _ref466 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
});

var SendAltFilled20 = /*#__PURE__*/React.forwardRef(function SendAltFilled20(_ref465, ref) {
  var children = _ref465.children,
      rest = _objectWithoutProperties(_ref465, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref466, children);
});

var _ref468 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
});

var SendAltFilled16 = /*#__PURE__*/React.forwardRef(function SendAltFilled16(_ref467, ref) {
  var children = _ref467.children,
      rest = _objectWithoutProperties(_ref467, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref468, children);
});

var _ref470 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
});

var SendFilled32 = /*#__PURE__*/React.forwardRef(function SendFilled32(_ref469, ref) {
  var children = _ref469.children,
      rest = _objectWithoutProperties(_ref469, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref470, children);
});

var _ref472 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
});

var SendFilled24 = /*#__PURE__*/React.forwardRef(function SendFilled24(_ref471, ref) {
  var children = _ref471.children,
      rest = _objectWithoutProperties(_ref471, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref472, children);
});

var _ref474 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
});

var SendFilled20 = /*#__PURE__*/React.forwardRef(function SendFilled20(_ref473, ref) {
  var children = _ref473.children,
      rest = _objectWithoutProperties(_ref473, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref474, children);
});

var _ref476 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
});

var SendFilled16 = /*#__PURE__*/React.forwardRef(function SendFilled16(_ref475, ref) {
  var children = _ref475.children,
      rest = _objectWithoutProperties(_ref475, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref476, children);
});

var _ref478 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
  transform: "translate(0 .005)"
});

var ServiceDesk32 = /*#__PURE__*/React.forwardRef(function ServiceDesk32(_ref477, ref) {
  var children = _ref477.children,
      rest = _objectWithoutProperties(_ref477, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref478, children);
});

var _ref480 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
  transform: "translate(0 .005)"
});

var ServiceDesk24 = /*#__PURE__*/React.forwardRef(function ServiceDesk24(_ref479, ref) {
  var children = _ref479.children,
      rest = _objectWithoutProperties(_ref479, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref480, children);
});

var _ref482 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
  transform: "translate(0 .005)"
});

var ServiceDesk20 = /*#__PURE__*/React.forwardRef(function ServiceDesk20(_ref481, ref) {
  var children = _ref481.children,
      rest = _objectWithoutProperties(_ref481, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref482, children);
});

var _ref484 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
  transform: "translate(0 .005)"
});

var ServiceDesk16 = /*#__PURE__*/React.forwardRef(function ServiceDesk16(_ref483, ref) {
  var children = _ref483.children,
      rest = _objectWithoutProperties(_ref483, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref484, children);
});

var _ref486 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
});

var _ref487 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
});

var Settings32 = /*#__PURE__*/React.forwardRef(function Settings32(_ref485, ref) {
  var children = _ref485.children,
      rest = _objectWithoutProperties(_ref485, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref486, _ref487, children);
});

var _ref489 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
});

var _ref490 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
});

var Settings24 = /*#__PURE__*/React.forwardRef(function Settings24(_ref488, ref) {
  var children = _ref488.children,
      rest = _objectWithoutProperties(_ref488, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref489, _ref490, children);
});

var _ref492 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
});

var _ref493 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
});

var Settings20 = /*#__PURE__*/React.forwardRef(function Settings20(_ref491, ref) {
  var children = _ref491.children,
      rest = _objectWithoutProperties(_ref491, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref492, _ref493, children);
});

var _ref495 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3\tc-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1\tC5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4\tc0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4\tc0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4\tc0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8\tL9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6\tC5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z"
});

var _ref496 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8\tc0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z"
});

var Settings16 = /*#__PURE__*/React.forwardRef(function Settings16(_ref494, ref) {
  var children = _ref494.children,
      rest = _objectWithoutProperties(_ref494, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref495, _ref496, children);
});

var _ref498 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
});

var SettingsAdjust32 = /*#__PURE__*/React.forwardRef(function SettingsAdjust32(_ref497, ref) {
  var children = _ref497.children,
      rest = _objectWithoutProperties(_ref497, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref498, children);
});

var _ref500 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
});

var SettingsAdjust24 = /*#__PURE__*/React.forwardRef(function SettingsAdjust24(_ref499, ref) {
  var children = _ref499.children,
      rest = _objectWithoutProperties(_ref499, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref500, children);
});

var _ref502 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
});

var SettingsAdjust20 = /*#__PURE__*/React.forwardRef(function SettingsAdjust20(_ref501, ref) {
  var children = _ref501.children,
      rest = _objectWithoutProperties(_ref501, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref502, children);
});

var _ref504 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
});

var SettingsAdjust16 = /*#__PURE__*/React.forwardRef(function SettingsAdjust16(_ref503, ref) {
  var children = _ref503.children,
      rest = _objectWithoutProperties(_ref503, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref504, children);
});

var _ref506 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
});

var Share32 = /*#__PURE__*/React.forwardRef(function Share32(_ref505, ref) {
  var children = _ref505.children,
      rest = _objectWithoutProperties(_ref505, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref506, children);
});

var _ref508 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
});

var Share24 = /*#__PURE__*/React.forwardRef(function Share24(_ref507, ref) {
  var children = _ref507.children,
      rest = _objectWithoutProperties(_ref507, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref508, children);
});

var _ref510 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
});

var Share20 = /*#__PURE__*/React.forwardRef(function Share20(_ref509, ref) {
  var children = _ref509.children,
      rest = _objectWithoutProperties(_ref509, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref510, children);
});

var _ref512 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
});

var Share16 = /*#__PURE__*/React.forwardRef(function Share16(_ref511, ref) {
  var children = _ref511.children,
      rest = _objectWithoutProperties(_ref511, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref512, children);
});

var _ref514 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
});

var ShareKnowledge32 = /*#__PURE__*/React.forwardRef(function ShareKnowledge32(_ref513, ref) {
  var children = _ref513.children,
      rest = _objectWithoutProperties(_ref513, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref514, children);
});

var _ref516 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
});

var ShareKnowledge24 = /*#__PURE__*/React.forwardRef(function ShareKnowledge24(_ref515, ref) {
  var children = _ref515.children,
      rest = _objectWithoutProperties(_ref515, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref516, children);
});

var _ref518 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
});

var ShareKnowledge20 = /*#__PURE__*/React.forwardRef(function ShareKnowledge20(_ref517, ref) {
  var children = _ref517.children,
      rest = _objectWithoutProperties(_ref517, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref518, children);
});

var _ref520 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
});

var ShareKnowledge16 = /*#__PURE__*/React.forwardRef(function ShareKnowledge16(_ref519, ref) {
  var children = _ref519.children,
      rest = _objectWithoutProperties(_ref519, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref520, children);
});

var _ref522 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
});

var ShoppingBag32 = /*#__PURE__*/React.forwardRef(function ShoppingBag32(_ref521, ref) {
  var children = _ref521.children,
      rest = _objectWithoutProperties(_ref521, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref522, children);
});

var _ref524 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
});

var ShoppingBag24 = /*#__PURE__*/React.forwardRef(function ShoppingBag24(_ref523, ref) {
  var children = _ref523.children,
      rest = _objectWithoutProperties(_ref523, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref524, children);
});

var _ref526 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
});

var ShoppingBag20 = /*#__PURE__*/React.forwardRef(function ShoppingBag20(_ref525, ref) {
  var children = _ref525.children,
      rest = _objectWithoutProperties(_ref525, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref526, children);
});

var _ref528 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
});

var ShoppingBag16 = /*#__PURE__*/React.forwardRef(function ShoppingBag16(_ref527, ref) {
  var children = _ref527.children,
      rest = _objectWithoutProperties(_ref527, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref528, children);
});

var _ref530 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "28",
  r: "2"
});

var _ref531 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "24",
  cy: "28",
  r: "2"
});

var _ref532 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
});

var ShoppingCart32 = /*#__PURE__*/React.forwardRef(function ShoppingCart32(_ref529, ref) {
  var children = _ref529.children,
      rest = _objectWithoutProperties(_ref529, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref530, _ref531, _ref532, children);
});

var _ref534 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "28",
  r: "2"
});

var _ref535 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "24",
  cy: "28",
  r: "2"
});

var _ref536 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
});

var ShoppingCart24 = /*#__PURE__*/React.forwardRef(function ShoppingCart24(_ref533, ref) {
  var children = _ref533.children,
      rest = _objectWithoutProperties(_ref533, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref534, _ref535, _ref536, children);
});

var _ref538 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "28",
  r: "2"
});

var _ref539 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "24",
  cy: "28",
  r: "2"
});

var _ref540 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
});

var ShoppingCart20 = /*#__PURE__*/React.forwardRef(function ShoppingCart20(_ref537, ref) {
  var children = _ref537.children,
      rest = _objectWithoutProperties(_ref537, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref538, _ref539, _ref540, children);
});

var _ref542 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "10",
  cy: "28",
  r: "2"
});

var _ref543 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: "24",
  cy: "28",
  r: "2"
});

var _ref544 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
});

var ShoppingCart16 = /*#__PURE__*/React.forwardRef(function ShoppingCart16(_ref541, ref) {
  var children = _ref541.children,
      rest = _objectWithoutProperties(_ref541, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref542, _ref543, _ref544, children);
});

var _ref546 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
});

var _ref547 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
});

var ShoppingCatalog32 = /*#__PURE__*/React.forwardRef(function ShoppingCatalog32(_ref545, ref) {
  var children = _ref545.children,
      rest = _objectWithoutProperties(_ref545, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref546, _ref547, children);
});

var _ref549 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
});

var _ref550 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
});

var ShoppingCatalog24 = /*#__PURE__*/React.forwardRef(function ShoppingCatalog24(_ref548, ref) {
  var children = _ref548.children,
      rest = _objectWithoutProperties(_ref548, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref549, _ref550, children);
});

var _ref552 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
});

var _ref553 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
});

var ShoppingCatalog20 = /*#__PURE__*/React.forwardRef(function ShoppingCatalog20(_ref551, ref) {
  var children = _ref551.children,
      rest = _objectWithoutProperties(_ref551, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref552, _ref553, children);
});

var _ref555 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
});

var _ref556 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2\tH6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
});

var ShoppingCatalog16 = /*#__PURE__*/React.forwardRef(function ShoppingCatalog16(_ref554, ref) {
  var children = _ref554.children,
      rest = _objectWithoutProperties(_ref554, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref555, _ref556, children);
});

var _ref558 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
});

var _ref559 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
});

var ShrinkScreen32 = /*#__PURE__*/React.forwardRef(function ShrinkScreen32(_ref557, ref) {
  var children = _ref557.children,
      rest = _objectWithoutProperties(_ref557, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref558, _ref559, children);
});

var _ref561 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
});

var _ref562 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
});

var ShrinkScreen24 = /*#__PURE__*/React.forwardRef(function ShrinkScreen24(_ref560, ref) {
  var children = _ref560.children,
      rest = _objectWithoutProperties(_ref560, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref561, _ref562, children);
});

var _ref564 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
});

var _ref565 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
});

var ShrinkScreen20 = /*#__PURE__*/React.forwardRef(function ShrinkScreen20(_ref563, ref) {
  var children = _ref563.children,
      rest = _objectWithoutProperties(_ref563, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref564, _ref565, children);
});

var _ref567 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
});

var _ref568 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
});

var ShrinkScreen16 = /*#__PURE__*/React.forwardRef(function ShrinkScreen16(_ref566, ref) {
  var children = _ref566.children,
      rest = _objectWithoutProperties(_ref566, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref567, _ref568, children);
});

var _ref570 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "15",
  height: "10",
  x: "15",
  y: "18",
  rx: "2"
});

var _ref571 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
});

var _ref572 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
});

var ShrinkScreenFilled32 = /*#__PURE__*/React.forwardRef(function ShrinkScreenFilled32(_ref569, ref) {
  var children = _ref569.children,
      rest = _objectWithoutProperties(_ref569, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref570, _ref571, _ref572, children);
});

var _ref574 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "15",
  height: "10",
  x: "15",
  y: "18",
  rx: "2"
});

var _ref575 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
});

var _ref576 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
});

var ShrinkScreenFilled24 = /*#__PURE__*/React.forwardRef(function ShrinkScreenFilled24(_ref573, ref) {
  var children = _ref573.children,
      rest = _objectWithoutProperties(_ref573, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref574, _ref575, _ref576, children);
});

var _ref578 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "15",
  height: "10",
  x: "15",
  y: "18",
  rx: "2"
});

var _ref579 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
});

var _ref580 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
});

var ShrinkScreenFilled20 = /*#__PURE__*/React.forwardRef(function ShrinkScreenFilled20(_ref577, ref) {
  var children = _ref577.children,
      rest = _objectWithoutProperties(_ref577, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref578, _ref579, _ref580, children);
});

var _ref582 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: "15",
  height: "10",
  x: "15",
  y: "18",
  rx: "2"
});

var _ref583 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
});

var _ref584 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
});

var ShrinkScreenFilled16 = /*#__PURE__*/React.forwardRef(function ShrinkScreenFilled16(_ref581, ref) {
  var children = _ref581.children,
      rest = _objectWithoutProperties(_ref581, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref582, _ref583, _ref584, children);
});

var _ref586 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
});

var Shuffle32 = /*#__PURE__*/React.forwardRef(function Shuffle32(_ref585, ref) {
  var children = _ref585.children,
      rest = _objectWithoutProperties(_ref585, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref586, children);
});

var _ref588 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
});

var Shuffle24 = /*#__PURE__*/React.forwardRef(function Shuffle24(_ref587, ref) {
  var children = _ref587.children,
      rest = _objectWithoutProperties(_ref587, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref588, children);
});

var _ref590 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
});

var Shuffle20 = /*#__PURE__*/React.forwardRef(function Shuffle20(_ref589, ref) {
  var children = _ref589.children,
      rest = _objectWithoutProperties(_ref589, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref590, children);
});

var _ref592 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
});

var Shuffle16 = /*#__PURE__*/React.forwardRef(function Shuffle16(_ref591, ref) {
  var children = _ref591.children,
      rest = _objectWithoutProperties(_ref591, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref592, children);
});

var _ref594 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
});

var Shuttle32 = /*#__PURE__*/React.forwardRef(function Shuttle32(_ref593, ref) {
  var children = _ref593.children,
      rest = _objectWithoutProperties(_ref593, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref594, children);
});

var _ref596 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
});

var Shuttle24 = /*#__PURE__*/React.forwardRef(function Shuttle24(_ref595, ref) {
  var children = _ref595.children,
      rest = _objectWithoutProperties(_ref595, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref596, children);
});

var _ref598 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
});

var Shuttle20 = /*#__PURE__*/React.forwardRef(function Shuttle20(_ref597, ref) {
  var children = _ref597.children,
      rest = _objectWithoutProperties(_ref597, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref598, children);
});

var _ref600 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
});

var Shuttle16 = /*#__PURE__*/React.forwardRef(function Shuttle16(_ref599, ref) {
  var children = _ref599.children,
      rest = _objectWithoutProperties(_ref599, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref600, children);
});

var _ref602 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
});

var Sigma32 = /*#__PURE__*/React.forwardRef(function Sigma32(_ref601, ref) {
  var children = _ref601.children,
      rest = _objectWithoutProperties(_ref601, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref602, children);
});

var _ref604 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
});

var Sigma24 = /*#__PURE__*/React.forwardRef(function Sigma24(_ref603, ref) {
  var children = _ref603.children,
      rest = _objectWithoutProperties(_ref603, ["children"]);

  return /*#__PURE__*/React.createElement(Icon, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref
  }, rest), _ref604, children);
});

export { QS16, QS20, QS24, QS32, QSAlt16, QSAlt20, QSAlt24, QSAlt32, Rocket16, Rocket20, Rocket24, Rocket32, Rotate16, Rotate20, Rotate24, Rotate32, RotateClockwise16, RotateClockwise20, RotateClockwise24, RotateClockwise32, RotateClockwiseAlt16, RotateClockwiseAlt20, RotateClockwiseAlt24, RotateClockwiseAlt32, RotateClockwiseAltFilled16, RotateClockwiseAltFilled20, RotateClockwiseAltFilled24, RotateClockwiseAltFilled32, RotateClockwiseFilled16, RotateClockwiseFilled20, RotateClockwiseFilled24, RotateClockwiseFilled32, RotateCounterclockwise16, RotateCounterclockwise20, RotateCounterclockwise24, RotateCounterclockwise32, RotateCounterclockwiseAlt16, RotateCounterclockwiseAlt20, RotateCounterclockwiseAlt24, RotateCounterclockwiseAlt32, RotateCounterclockwiseAltFilled16, RotateCounterclockwiseAltFilled20, RotateCounterclockwiseAltFilled24, RotateCounterclockwiseAltFilled32, RotateCounterclockwiseFilled16, RotateCounterclockwiseFilled20, RotateCounterclockwiseFilled24, RotateCounterclockwiseFilled32, Row16, Row20, Row24, Row32, RowCollapse16, RowCollapse20, RowCollapse24, RowCollapse32, RowExpand16, RowExpand20, RowExpand24, RowExpand32, Rss16, Rss20, Rss24, Rss32, Rule16, Rule20, Rule24, Rule32, Ruler16, Ruler20, Ruler24, Ruler32, RulerAlt16, RulerAlt20, RulerAlt24, RulerAlt32, Run16, Run20, Run24, Run32, Save16, Save20, Save24, Save32, SaveModel16, SaveModel20, SaveModel24, SaveModel32, Scale16, Scale20, Scale24, Scale32, Scalpel16, Scalpel20, Scalpel24, Scalpel32, Scan16, Scan20, Scan24, Scan32, ScatterMatrix16, ScatterMatrix20, ScatterMatrix24, ScatterMatrix32, Schematics16, Schematics20, Schematics24, Schematics32, Scooter16, Scooter20, Scooter24, Scooter32, ScooterFront16, ScooterFront20, ScooterFront24, ScooterFront32, Screen16, Screen20, Screen24, Screen32, ScreenOff16, ScreenOff20, ScreenOff24, ScreenOff32, Script16, Script20, Script24, Script32, ScriptReference16, ScriptReference20, ScriptReference24, ScriptReference32, Sdk16, Sdk20, Sdk24, Sdk32, Search16, Search20, Search24, Search32, Security16, Security20, Security24, Security32, Select_0116, Select_0120, Select_0124, Select_0132, Select_0216, Select_0220, Select_0224, Select_0232, Send16, Send20, Send24, Send32, SendAlt16, SendAlt20, SendAlt24, SendAlt32, SendAltFilled16, SendAltFilled20, SendAltFilled24, SendAltFilled32, SendFilled16, SendFilled20, SendFilled24, SendFilled32, ServiceDesk16, ServiceDesk20, ServiceDesk24, ServiceDesk32, Settings16, Settings20, Settings24, Settings32, SettingsAdjust16, SettingsAdjust20, SettingsAdjust24, SettingsAdjust32, Share16, Share20, Share24, Share32, ShareKnowledge16, ShareKnowledge20, ShareKnowledge24, ShareKnowledge32, ShoppingBag16, ShoppingBag20, ShoppingBag24, ShoppingBag32, ShoppingCart16, ShoppingCart20, ShoppingCart24, ShoppingCart32, ShoppingCatalog16, ShoppingCatalog20, ShoppingCatalog24, ShoppingCatalog32, ShrinkScreen16, ShrinkScreen20, ShrinkScreen24, ShrinkScreen32, ShrinkScreenFilled16, ShrinkScreenFilled20, ShrinkScreenFilled24, ShrinkScreenFilled32, Shuffle16, Shuffle20, Shuffle24, Shuffle32, Shuttle16, Shuttle20, Shuttle24, Shuttle32, Sigma24, Sigma32, WatsonHealthRotate_18016, WatsonHealthRotate_18020, WatsonHealthRotate_18024, WatsonHealthRotate_18032, WatsonHealthRotate_36016, WatsonHealthRotate_36020, WatsonHealthRotate_36024, WatsonHealthRotate_36032, WatsonHealthSaveAnnotation16, WatsonHealthSaveAnnotation20, WatsonHealthSaveAnnotation24, WatsonHealthSaveAnnotation32, WatsonHealthSaveImage16, WatsonHealthSaveImage20, WatsonHealthSaveImage24, WatsonHealthSaveImage32, WatsonHealthSaveSeries16, WatsonHealthSaveSeries20, WatsonHealthSaveSeries24, WatsonHealthSaveSeries32, WatsonHealthScalpelCursor16, WatsonHealthScalpelCursor20, WatsonHealthScalpelCursor24, WatsonHealthScalpelCursor32, WatsonHealthScalpelLasso16, WatsonHealthScalpelLasso20, WatsonHealthScalpelLasso24, WatsonHealthScalpelLasso32, WatsonHealthScalpelSelect16, WatsonHealthScalpelSelect20, WatsonHealthScalpelSelect24, WatsonHealthScalpelSelect32 };
